<template lang="">
    <DashView>
        <div class="container-fluid pt-4 px-4">
            <div class="row g-4">
                <!-- Column -->
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <h3 class="text-center underline">Ajouter Utilisateur&nbsp;<a href="/user-all"><i class="fa fa-file" title="Lister Utilisateurs"></i></a></h3><br>
                            <div class="row" v-if="validationErrors.length>0">
                                  <div class="offset-2 col-md-8 col-sm-12 alert alert-danger alert-md text-danger mx-auto">
                                      <ul v-if="validationErrors.length>0" class="list-unstyled text-center mx-auto">
                                          <li v-for="(error,key) in validationErrors" :key="key" class="p-2"><div class="">{{error}}</div></li>
                                      </ul>
                                  </div>
                              </div>
                            <div class="alert alert-success text-success" v-if="success_msg">{{success_msg}}</div>
                          <form @submit.prevent="registerUser" ref="fuser" class="mb-4">
                              <div class="col-sm-12">
                                  <div class="row">
                                      <div class="col-sm-4 form-group">
                                          <label for="usname">Nom <span class="required">*</span></label>
                                          <input type="text"  title="Ajouter Nom" placeholder="Nom" v-model="form.nom"  @keyup="validateName" @input="validateName" @focus="validateName" required id="usname" class="form-control" autofocus="true">
                                          <p v-if="alertName" class="alert"> {{ alertName }} </p>
                                      </div>
                                      <div class="col-sm-4 form-group">
                                          <label for="usfname">Prénom <span class="required">*</span></label>
                                          <input type="text"  title="Ajouter Prénom" v-model="form.prenom" required placeholder="Prénom" name="usfname" @keyup="validateFirstName" @focus="validateFirstName" class="form-control">
                                          <p v-if="alertFirstName" class="alert"> {{ alertFirstName }} </p>
                                      </div>
                                      <div class="col-sm-4 form-group">
                                        <label for="ustelephone">Téléphone <span class="required">*</span></label>
                                        <input type="number" v-model="form.phone"  title="Format(8 Chiffres):42003583" @keyup="validatePhone" @focus="validatePhone" placeholder="42003583"  name="ustelephone" id="ustelephone" class="form-control" autocomplete="off" required>
                                        <p v-if="alertPhone" class="alert"> {{ alertPhone }} </p>
                                    </div>
                                  </div>				
                                  <div class="row">
                                      <div class="col-sm-4 form-group">
                                          <label for="usmail">Email<span class="required">*</span></label>
                                              <input type="email" title="Ajouter Email Valide" v-model="form.email" placeholder="zode@zode-ht.com" name="usmail" id="usmail" class="form-control" required @keyup="validateEmail" @focus="validateEmail">
                                              <p v-if="alertMail" class="alert"> {{ alertMail }} </p>
                                      </div>                                                              
                                      <div class="col-sm-4 form-group">
                                          <label for="usrole">Rôle <span class="required">*</span></label>
                                          <select class="form-control custom-select text-center" id="usrole" required v-model="form.role" >
                                              <option value="">--Rôles--</option>
                                              <template v-if="roles.length > 0">
                                              <option v-for="(role,key) in roles" :key="key" :value="role.id">{{ role.role }}</option>
                                              </template>
                                              <template v-else>
                                              <option value="">Aucun Rôle trouvé</option>
                                              </template>
                                          </select>
                                      </div>                                                                
                                      <div class="col-sm-4 form-group">
                                        <label for="ussexe">Sexe</label><br/>
                                        <select class="form-control custom-select text-center"  required v-model="form.sexe">
                                            <option value="">--Choisir--</option>
                                            <option value="1">Masculin</option>
                                            <option value="0">Feminin</option>
                                            <option value="2">Autre</option>
                                        </select>
                                    </div>                                                                
                                  </div>				
                                  <div class="row"> 
                                    <div class="col-sm-4 form-group" v-if="form.role==3">
                                        <label for="specialties">Spécialités <span class="required">*</span></label>
                                        <select class="form-control custom-select text-center" id="specialties" required v-model="form.specialties" multiple style="height: auto; width: 100%; max-height: 150px; overflow-y: auto;">
                                            <option value="">--Spécialités--</option>
                                            <template v-if="specialties.length > 0">
                                                <option v-for="(specialty, key) in specialties" :key="key" :value="specialty.id">{{ specialty.specialite }}</option>
                                            </template>
                                            <template v-else>
                                                <option value="">Aucune spécialité trouvée</option>
                                            </template>
                                        </select>
                                    </div>                                                           
                                      <div class="col-sm-4 form-group">
                                          <label for="lcredit">Password</label>
                                          <input  type="password" v-model="form.pass" title="Veuillez entrer nombre!" autocomplete="off" class="form-control">
                                          <!-- <p v-if="alertCredit" class="alert"> {{ alertCredit }} </p> -->
                                      </div>                                                                
                                      <div class="col-sm-4 form-group">
                                          <label for="lcredit">Confirmer Password</label>
                                          <input  type="password" v-model="form.cpass" title="Veuillez entrer nombre!" autocomplete="off" class="form-control">
                                          <!-- <p v-if="alertCredit" class="alert"> {{ alertCredit }} </p> -->
                                      </div>                                                                
                                  </div>
                                  <div class="row mb-5 pt-5">
                                    <div class="pt-2">
                                        <button type="submit" class="btn btn-block btn-lg col-12" style="background:#00C853; color: #fff;">Enrégistrer</button>
                                    </div>
                                </div>	
                                <br>	
                              </div>
                          </form> 
                        </div>
                    </div>
                </div>
                <!-- Column -->
            </div>
        </div>
    </DashView>
</template>
<script>
    import axios from 'axios'
    const base_url=process.env.VUE_APP_API_URL;
    import DashView from "@/components/DashView.vue"
export default {
    name:"UserRegister",
    components:{
        DashView
    },
    data(){
        return{
            success_msg:'',
            validationErrors:[],
            specialties:[],
            accessToken:JSON.parse(localStorage.getItem('user_zgh')).token ?? '',
            form :{
            nom: '',
            prenom: '',
            email:'',
            sexe:1,
            phone:'',
            role:'',
            pass:'',
            cpass:'',
            specialties:[]
            },
            alertMail: '',
            alertName:'',
            alertFirstName:'',
            alertPhone:'',
            regexNonVide:/^\s*$/,
            roles:[]
        }
    },
    methods:{
    formatDate(dateString) {
            const date = new Date(dateString)
            const day = ('0' + date.getDate()).slice(-2)
            const month = ('0' + (date.getMonth() + 1)).slice(-2)
            const year = date.getFullYear()
            return `${day}-${month}-${year}`
        },
        redirectTo(path) {
            this.$router.push(path);
            setTimeout(function() {
                location.reload();
            }, 1);
        },
        validateEmail() {
            //const regexEmail = /\S+@\S+\.\S+/;
            const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!regexEmail.test(this.form.email)) {
                this.alertMail = 'Saisir une adresse email valide!';
            } else {
                this.alertMail = '';
            }
            if (this.regexNonVide.test(this.form.email)) {
                this.alertMail = 'Veuillez remplir ce champ!';
            }
        },
        validateName() {
            const regexName = /^[a-zA-Z\s\-]+$/;
            if (!regexName.test(this.form.nom)) {
                this.alertName = 'Veuillez saisir un nom valide!';
            } else {
                this.alertName = '';
            }
            if (this.regexNonVide.test(this.form.nom)) {
                this.alertName = 'Veuillez remplir ce champ!';
            }else {
                this.alertName = '';
            }
        },
        validateFirstName(){
            const regexFName = /^[a-zA-Z\s\-]+$/;
            if (!regexFName.test(this.form.prenom)) {
                this.alertFirstName = 'Veuillez saisir un prenom valide!';
            } else {
                this.alertFirstName = '';
            }
            if (this.regexNonVide.test(this.form.prenom)) {
                this.alertFirstName = 'Veuillez remplir ce champ!';
            }
        },
        validatePhone() {
            //!Seulement 8 chiffres commencant par 3 ou 4 ou 5
            const regexPhone = /^[345]\d{7}$/;
            if (!regexPhone.test(this.form.phone)) {
                this.alertPhone = 'Saisir un numero valide : 8 chiffres, ex :42003583)';
            } else {
                this.alertPhone = '';
            }
            if (this.regexNonVide.test(this.form.phone)) {
                this.alertPhone = 'Veuillez remplir ce champ!';
            }
        },
        registerUser(){
            console.log('ok');
        const control = !!(this.form.nom && this.form.role && this.form.prenom && this.form.email && this.form.pass && this.form.cpass && (this.form.pass===this.form.cpass));
        console.log(control);
        if(control){
                const $data ={
                nom : this.form.nom,
                prenom : this.form.prenom,
                mail : this.form.email,
                sexe:this.form.sexe,
                telephone: this.form.phone,
                role:this.form.role,
                password:this.form.pass,
                specialites:this.form.specialties
            };
            console.log($data);
            // return false;
            this.$refs.fuser.reset();
            axios.post(`${base_url}/auth/register`,$data,{  
                headers:{
                    Accept:'application/json',
                    'Content-Type':'application/json;charset=UTF-8',
                    Authorization:`Bearer ${this.accessToken}`
                }
            })
            .then((response)=>{
                console.log(response.data);
                if(response.status==201){
                    this.success_msg = `Utilisateur ajouté avec success!`;
                    let self = this;
                    setTimeout(function() {
                            self.$router.push('/user-all');
                        //   location.reload();
                        },2000);
                }
                else{
                    console.log('Erreur!!!');
                }
            })
            .catch((error)=>{
                // console.log(error);
                if (error?.response?.status === 401) {
                        const error_msg = error.response.data.errors;
                        this.displayValidationErrors(error.response.data.errors);                       
                } 
                else if(error?.response?.status === 403){
                    console.log('NO access');
                    $('#openModalNoAccess').trigger('click');
                }
                else {
                // Gérer d'autres erreurs ici
                console.log('Autre erreur:', error);
                }
            })
        }
        
        },
        displayValidationErrors(errors) {
            this.validationErrors = [];

            // Parcourir les erreurs et les ajouter au tableau
            Object.keys(errors).forEach(field => {
                this.validationErrors.push(errors[field][0]);
            });

            // Définir un délai de 5 secondes avant de vider les erreurs
            setTimeout(() => {
                this.clearValidationErrors();
            }, 5000);

        },
        clearValidationErrors() {
            this.validationErrors = [];
        },
        getSpecialites(){
            axios.get(`${base_url}/specialites`,{
                headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response)=>{
                    console.log(response?.data);
                    if(response?.status==200){
                        // console.log(response?.data);
                        if(response?.data?.length>0){

                            this.specialties = response.data;
                        }
                        // console.log(this.roles);
                    }                
                })
                .catch((error)=>{
                    console.log('Une erreur est survenue!');
                    console.error(error);
                });
        }
    },
    created(){
        // (JSON.parse(localStorage.getItem('user_zgc')).code_role)>3 ? this.$router.push('/'):true;
        axios.get(`${base_url}/roles`,{
                headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response)=>{
                    // console.log(response?.data);
                    if(response?.status==200){
                        // console.log(response?.data);
                        if(response?.data?.length>0){

                            this.roles = response.data.filter(element=>element.role!=='CLIENT');
                        }
                        // console.log(this.roles);
                    }                
                })
                .catch((error)=>{
                    console.log('Une erreur est survenue!');
                    console.error(error);
                });
    },
    mounted(){
        this.getSpecialites();
    }
}
</script>
<style scoped>
    .alert{
      color:red;
    }
    @media (max-width: 600px) {
        form {
            height: 80vh; /* Utilise 80% de la hauteur de la vue pour la forme */
            overflow-x: auto; /* Ajoute une barre de défilement horizontale si nécessaire */
            overflow-y: auto; /* Ajoute une barre de défilement verticale si nécessaire */
        }
        .form-group {
            margin-bottom: 15px;
        }
        .btn-submit {
            width: 100%;
            display: block;
        }
        .pt-2 {
            padding-top: 15px;
        }
    }
</style>